import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import UploadFile from '@/components/layout/uploadFile/UploadFile.vue'
import Datefield from '@/components/layout/datefield/Datefield.vue'
import redirecionamento from '@/util/redirecionamentoRotasConteudo'
import { BModal, BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import { mapState } from 'vuex'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'

export default {
  name: 'cadastro-galeriaFotos',
  components: {
    cabecalho,
    menuLateral,
    Datefield,
    UploadFile,
    imageStream,
    'b-spinner': BSpinner,
    'b-toast': BToast,
    'b-modal': BModal
  },

  computed: {
    estaEditando () {
      if (util.valorEhNulo(this.formulario.id)) {
        return false
      }
      return true
    },
    ...mapState('auth', ['tipoDeAcesso'])
  },

  data: () => {
    return {
      idAlbum: null,
      idFoto: null,
      listaFotosAlbum: [],
      formulario: {
        id: null,
        date: null,
        title: null,
        description: null,
        image_file_name: null,
        image_file_size: null,
        image_content_type: null,
        grupo: null
      },
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        },
        manipulandoDados: {
          status: false,
          mensagem: ''
        }
      },
      retorno: {
        sucesso: false,
        mensagem: '',
        listaDeErros: []
      }
    }
  },

  mounted () {
    this.idAlbum = this.$route.params.id
    if (!util.valorEhNulo(this.idAlbum)) {
      this.obterAlbum()
    }
  },

  methods: {
    async obterAlbum () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        const resposta = await this.axios.get('/album/' + this.idAlbum)
        this.formulario.id = resposta.data.retorno.dados.id
        this.formulario.date = util.formatarData(resposta.data.retorno.dados.date, 'YYYY-MM-DD')
        this.formulario.title = resposta.data.retorno.dados.title
        this.formulario.description = resposta.data.retorno.dados.description
        this.formulario.image_file_name = resposta.data.retorno.dados.image_file_name
        this.formulario.image_file_size = resposta.data.retorno.dados.image_file_size
        this.formulario.image_content_type = resposta.data.retorno.dados.image_content_type
        this.formulario.grupo = resposta.data.retorno.dados.grupo

        this.obterFotosDoAlbum()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    async obterFotosDoAlbum () {
      try {
        const resposta = await this.axios.get('/album/' + this.idAlbum + '/fotos')
        this.listaFotosAlbum = resposta.data.retorno.dados
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },

    showModalExcluirFotosAlbum (id) {
      this.idFoto = id
      this.$bvModal.show('modalExcluirFoto')
    },

    async excluirFotoDoAlbum () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.delete('/album/foto/' + this.idFoto + '/remover')
        this.definirFlagCarregandoDados(false, '')
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem

        if (this.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        }
        this.obterAlbum(this.idAlbum)
      } catch (e) {
        this.definirFlagCarregandoDados(false, '')
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    },

    async salvarRegistro () {
      this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)
      try {
        let resposta = null
        let dadosFormulario = util.mapearObjetos(this.formulario, {})

        dadosFormulario.date = util.formatarData(dadosFormulario.date)
        const formData = this.montarObjetoDeEnvio(dadosFormulario)

        resposta = await this.axios.post('/album/salvar', formData)
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem
        this.retorno.listaDeErros = resposta.data.retorno.listaDeErros
        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const formData = new FormData()
      const campos = Object.entries(dadosFormulario)
      const capaAlbum = ['photo_album']
      const fotosAlbum = ['photos']
      const camposIgnorados = [...capaAlbum, ...fotosAlbum]

      for (let [chave, valor] of campos) {
        if (!camposIgnorados.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor)
        }

        if (capaAlbum.includes(chave) && !util.valorVazio(valor)) {
          formData.append(chave, valor, valor.name)
        }

        if (fotosAlbum.includes(chave) && !util.valorVazio(valor)) {
          for (let foto of valor) {
            formData.append(chave + '[]', foto, foto.name)
          }
        }
      }
      return formData
    },

    tratarAposSalvarRegistro () {
      if (this.retorno.sucesso) {
        this.$router.push({ name: redirecionamento.obterRota(this.tipoDeAcesso, 'galeriaFotos') }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        })
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    }
  }
}
